import React from 'react';
import { Play, Pause, SkipBack, SkipForward, Volume2, VolumeX, Maximize } from 'lucide-react';

export const Scrubber = ({ progress = 0, buffered = 0, onSeek, testId = 'film-scrubber', className = '' }) => {
  const seek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const clientX = e.clientX ?? (e.touches && e.touches[0] ? e.touches[0].clientX : null);
    if (clientX == null) return;
    onSeek(Math.max(0, Math.min(1, (clientX - rect.left) / rect.width)));
  };
  return (
    <div className={`th-scrub ${className}`} onClick={seek} onTouchStart={seek} onTouchMove={seek} role="slider" aria-label="Film progress"
      aria-valuenow={Math.round(progress)} aria-valuemin={0} aria-valuemax={100} tabIndex={0} data-testid={testId}>
      <div className="th-scrub-track">
        <div className="th-scrub-buffer" style={{ width: `${Math.min(100, buffered)}%` }} />
        <div className="th-scrub-fill" style={{ width: `${progress}%` }} />
        <div className="th-scrub-knob" style={{ left: `${progress}%` }} />
      </div>
    </div>
  );
};

export const Transport = ({ isPlaying, onPrev, onNext, onToggle, size = 'md' }) => {
  const big = size === 'lg';
  return (
    <div className="flex items-center gap-1" data-testid="film-transport">
      <button type="button" onClick={onPrev} className="th-icon-btn" aria-label="Previous film" data-testid="film-prev-btn"><SkipBack size={18} /></button>
      <span className="th-frame th-cut th-cut-sm inline-flex is-active">
        <button type="button" onClick={onToggle} aria-label={isPlaying ? 'Pause' : 'Play'} data-testid="film-play-pause-btn"
          className={`th-cut th-cut-sm th-solid flex items-center justify-center ${big ? 'w-16 h-16' : 'w-12 h-12'}`} style={{ color: 'var(--th-accent-soft)' }}>
          {isPlaying ? <Pause size={big ? 24 : 20} strokeWidth={1.5} /> : <Play size={big ? 24 : 20} strokeWidth={1.5} className="ml-0.5" />}
        </button>
      </span>
      <button type="button" onClick={onNext} className="th-icon-btn" aria-label="Next film" data-testid="film-next-btn"><SkipForward size={18} /></button>
    </div>
  );
};

export const MuteButton = ({ muted, onToggle }) => (
  <button type="button" onClick={onToggle} className="th-icon-btn" aria-label={muted ? 'Sound on' : 'Mute'} data-testid="film-mute-btn">
    {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
  </button>
);

export const FullscreenButton = ({ onToggle }) => (
  <button type="button" onClick={onToggle} className="th-icon-btn" aria-label="Fullscreen" data-testid="film-fullscreen-btn"><Maximize size={18} /></button>
);
